module.exports = __webpack_public_path__ + "static/media/kidsbaby_4.25e67b9a.jpg";